<template>
    <div>
        <p class="my-4 text-blue-500 small md:mt-10">Common searches</p>
        <ul class="flex flex-wrap text-blue-500 small md:flex-no-wrap md:flex-col md:items-start">
            <li
                v-for="(item, index) in suggestions"
                :key="index"
                class="px-2 mb-1 mr-2 border border-blue-100 rounded md:mb-2 cursor-pointer"
            >
                <span @click="updateCurrentRefinement(item)">
                    {{ item }}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import { ref, getCurrentInstance } from '@vue/composition-api';

const updateCurrentRefinement = (value) => {
    const searchBox = document.querySelector('.ais-SearchBox input');
    searchBox.value = value;
    searchBox.dispatchEvent(new Event('input'));
};

export default {
    setup() {
        const instance = getCurrentInstance();
        const suggestions = ref([]);

        if (instance?.proxy?.$root?.suggestions) {
            suggestions.value = JSON.parse(instance.proxy.$root.suggestions);
        }

        return {
            suggestions,
            updateCurrentRefinement
        };
    }
};
</script>
